(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cellec-common-categories"] && !Shopify.designMode) return;
  try {
    
const header_categories = new Swiper('.js-slider',{
    slidesPerView:6,
    spaceBetween:5,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    autoplay:true,

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },

    breakpoints:{
        750:{
            slidesPerView:12,
            spaceBetween:10
        }
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cellec-index-sns-posts"] && !Shopify.designMode) return;
  try {
    
var swiper_index_sns = new Swiper(".cellec-index-sns-posts__posts", {
    slidesPerView: 2.3,
    spaceBetween: 12,
    freeMode: true,
    navigation: {
        nextEl: ".ua-swiper-next",
        prevEl: ".ua-swiper-prev",
    },
    scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 4.5,
            spaceBetween: 24
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 28
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cellec-sns-list-topix"] && !Shopify.designMode) return;
  try {
    
let sns_tags = document.querySelectorAll('.cellec-sns-list-tags__posts')
sns_tags.forEach(tag => {
    var swiper_index_sns = new Swiper(tag, {
        slidesPerView: 2.5,
        spaceBetween: 10,
        freeMode: true,
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: true,
        },
        breakpoints: {
            768:{
                slidesPerView: 6,
                spaceBetween: 20
            }
        }
    });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cellec-sns-main"] && !Shopify.designMode) return;
  try {
    
const breakPoint = 768

    var swiper_thumb = new Swiper(".js-swiper-sns-thumb", {
      loop: true,
      spaceBetween: 20,
      slidesPerView: 3.5,
      freeMode: true,
      watchSlidesProgress: true,
    });

    var swiper_main = new Swiper(".js-swiper-sns-image", {
        loop: true,
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper_thumb,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        }, 
    });

    if(window.innerWidth<breakPoint){
        document.querySelectorAll('.cellec-sns-article--detail').forEach((el) => {
            el.classList.add('swiper-slide')
        })
        var swiper_otherposts = new Swiper(".cellec-sns-otherposts__posts", {
            slidesPerView: 3.3,
            spaceBetween: 10,
            freeMode: true,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: true,
            },
        });
    }


  } catch(e) { console.error(e); }
})();
})();
